module.exports = __webpack_public_path__ + "img/monsantoAnniston.dda2444a.jpg";